import { useState } from 'react';

/**
 * Custom hook to manage Nova UI credentials modal state
 * Encapsulates all nova modal logic for easy extraction/replacement
 */
export const useNovaCredentialsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return {
    isOpen,
    openModal,
    closeModal,
  };
};
